import Loading from '../../../components/layout/Loading'
import { useI18N } from '../../../../libraries/i18n/hook'
import ErrorMessage from '../../../components/errors/ErrorMessage'
import ContinueWatchingVideoCard from '../../../components/content/ContinueWatchingVideoCard'
import { useContinueWatchingVideos } from '../../../../hocs/content/useVideos'

const LIMIT = 1
const ContinueWatching = () => {
  const { t } = useI18N()
  const { data, isLoading, error } = useContinueWatchingVideos(LIMIT)

  if(isLoading) { return <Loading /> }
  if(error) { return <ErrorMessage message={error.message} /> }
  const video = data?.[0]
  if(!video) { return null }
  return (
    <div>
      <h2>{t('content.videos.continueWatching')}</h2>
      <ContinueWatchingVideoCard video={video} />
    </div>
  )
}

export default ContinueWatching
